import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { AlertService } from 'app/components/ui/alert/alert.service';
import { AccessContextService } from 'app/core/auth/access-context.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    private _accessDeniedPending = false;
    private _isSigningOut = false;

    constructor(
        private _authService: AuthService,
        private _router: Router,
        private _alertService: AlertService,
        private _accessContext: AccessContextService
    )
    {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        let newReq = req.clone();

        if ( this._authService.accessToken)
        {
            newReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
            });
        }

        // Declara o contexto de acesso (tela de origem) quando definido. O
        // backend usa esse header para liberar endpoints compartilhados entre
        // uma tela negada e esta (modelo Direct vs Indirect Access). Só é
        // adicionado — nunca remove autenticação ou outros headers.
        const context = this._accessContext.current();
        if ( context )
        {
            newReq = newReq.clone({
                headers: newReq.headers.set('X-Access-Context', context)
            });
        }

        return next.handle(newReq).pipe(
            catchError((error) => {

                if ( error instanceof HttpErrorResponse && error.status === 401 )
                {
                    if ( this._isSigningOut )
                    {
                        return EMPTY;
                    }
                    this._isSigningOut = true;
                    this._authService.signOut();
                    this._router.navigate(['/login']);
                    return EMPTY;
                }

                if (
                    error instanceof HttpErrorResponse
                    && error.status === 403
                    && error.error?.code === 'ACCESS_DENIED'
                    && !this._accessDeniedPending
                )
                {
                    this._accessDeniedPending = true;

                    this._router.navigate(['/home']).finally(() =>
                    {
                        setTimeout(() =>
                        {
                            this._alertService.warn('Você não tem permissão para acessar este recurso.', { autoClose: true });

                            setTimeout(() =>
                            {
                                this._accessDeniedPending = false;
                            }, 3000);
                        }, 500);
                    });
                }

                return throwError(error);
            })
        );
    }
}
